import { StartTaskDto } from "@myapp/contract";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { taskApi } from "../service";
import { taskKeys } from "../task.keys";

export function useStartTask(id: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto: StartTaskDto) =>
      taskApi.start(id, dto).then((r) => r.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: taskKeys.detail(id) });
      queryClient.invalidateQueries({ queryKey: taskKeys.lists() });
      queryClient.invalidateQueries({ queryKey: taskKeys.all });
    },
  });
}
